import './Certificates.css';
import { useEffect, useState } from 'react';
import imgBuildingIntelligence from './IMAGE/BUILDING INTELLIGENCE.jpg';
import imgCareerStories from './IMAGE/CAREER STORIES.png';
import imgCIDR from './IMAGE/CIDR.png';
import imgDesignOfRiscV from './IMAGE/DESIGN OF RISC-V.png';
import imgHIV from './IMAGE/HIV.jpg';
import imgPart1 from './IMAGE/PART1.PNG';
import imgPart2 from './IMAGE/PART2.png';
import imgCollab from './IMAGE/COLLAB.jpeg';

function Certificates({ onNavigateHome }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const certs = [
    {
      title: "Collaborative Project Presentation and Prototype Exhibition",
      shortName: "Best Research & Prototype",
      org: "FAITH Colleges",
      date: "April 2026",
      img: imgCollab,
      tags: ["FAITH Colleges", "Engineering"],
      badge: "Top Award"
    },
    {
      title: "Building Sustainable Future: Empowering Communities through HIV Awareness and Education",
      shortName: "HIV Awareness Seminar",
      org: "Seminar Participation",
      date: "2024",
      img: imgHIV,
      tags: ["Seminar", "Community"],
      badge: null
    },
    {
      title: "Building Intelligence: Where Computer Engineering Meets Data Science",
      shortName: "Building Intelligence",
      org: "Webinar",
      date: "November 2025",
      img: imgBuildingIntelligence,
      tags: ["Webinar", "Data Science"],
      badge: null
    },
    {
      title: "Design of RISC-V Microprocessors",
      shortName: "Design of RISC-V",
      org: "Webinar",
      date: "November 6, 2025",
      img: imgDesignOfRiscV,
      tags: ["Webinar", "Microprocessors"],
      badge: null
    },
    {
      title: "Arduino Workshop Part 1: Arduino Coding Skills Preparation for Hardware",
      shortName: "Arduino Workshop Pt.1",
      org: "FAITH Computer Engineering Society",
      date: "September 8, 2025",
      img: imgPart1,
      tags: ["Workshop", "Arduino"],
      badge: null
    },
    {
      title: "Engineering the Future: Career Stories and Industry Insights",
      shortName: "Career Stories",
      org: "First Asia Institute of Technology and Humanities",
      date: "March 29, 2025",
      img: imgCareerStories,
      tags: ["FAITH", "Industry"],
      badge: null
    },
    {
      title: "Arduino Workshop Part 2: Integration of Hardware",
      shortName: "Arduino Workshop Pt.2",
      org: "FAITH Computer Engineering Society",
      date: "September 24, 2025",
      img: imgPart2,
      tags: ["Workshop", "Hardware"],
      badge: null
    },
    {
      title: "3rd Annual Conference of the Center for Integrated Circuit and Device Research (CIDR)",
      shortName: "CIDR Conference",
      org: "Novotel, Araneta City, Quezon City",
      date: "August 11-12, 2025",
      img: imgCIDR,
      tags: ["Conference", "Research"],
      badge: null
    }
  ];

  const [selected, setSelected] = useState(0);
  const active = certs[selected];

  return (
    <div className="cert-page">
      {/* ── Hero Strip ── */}
      <div className="cert-hero-strip">
        <div className="cert-strip-inner">
          <p className="cert-strip-label">Continuous Learning</p>
          <h1 className="cert-strip-name">Certificates & Seminars</h1>
          <p className="cert-strip-role">Professional development through workshops and online learning.</p>
          <div className="hero-stats-row">
            <span className="hero-stat-pill">▸ 8 Certifications</span>
            <span className="hero-stat-pill">▸ Workshops & Conferences</span>
            <span className="hero-stat-pill">▸ Industry Seminars</span>
          </div>
          <div className="hero-watermark">✦</div>
        </div>
      </div>

      {/* ── Main Content: Sidebar + Detail ── */}
      <main className="cert-main">
        <div className="cert-layout">
          {/* Left sidebar */}
          <div className="cert-sidebar">
            {certs.map((item, idx) => (
              <button
                className={`cert-sidebar-item ${idx === selected ? 'active' : ''}`}
                key={idx}
                onClick={() => setSelected(idx)}
              >
                <div className="cert-sidebar-thumb">
                  <img src={item.img} alt={item.shortName} />
                </div>
                <span className="cert-sidebar-label">{item.shortName}</span>
              </button>
            ))}
          </div>

          {/* Right detail panel */}
          <div className="cert-detail">
            <div className="cert-detail-preview">
              <img src={active.img} alt={active.title} className="cert-detail-img" />
            </div>
            <div className="cert-detail-info">
              {active.badge && <span className="cert-badge">{active.badge}</span>}
              <h2 className="cert-detail-title">{active.title}</h2>
              <p className="cert-detail-meta">
                {active.org} · {active.date}
              </p>
              <div className="cert-detail-tags">
                {active.tags.map((tag, i) => (
                  <span className="cert-tag" key={i}>{tag}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* ── Footer ── */}
      <footer className="cert-footer">
        <p>Christian D. Kalaw &copy; {new Date().getFullYear()}</p>
        <button className="cert-footer-back" onClick={onNavigateHome}>Back to Portfolio</button>
      </footer>
    </div>
  );
}

export default Certificates;
